import type { LC_CloseMonthlyCutsOut, MonthlyCutsClosureSummary } from '../types';


export function mapMonthlyCutsClosureSummary(
  transport: LC_CloseMonthlyCutsOut,
): MonthlyCutsClosureSummary {
  return {
    closedIds: transport.closedIds,
    skippedIds: transport.skippedIds,
    notFoundIds: transport.notFoundIds,
  };
}
